class HotspotButton extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('hotspot-generator');
    this.leftOffset = this.style.left ? this.style.left.replace('%', '') : null;
    this.topOffset = this.style.top ? this.style.top.replace('%', '') : null;
    // Either passed on manual creation or via markup when pre-populating
    this.hotspotTitle = this.querySelector('[data-hotspot-title]')
      ? this.querySelector('[data-hotspot-title]').value
      : null;
    this.hotspotContent = this.querySelector('[data-hotspot-content]')
      ? this.querySelector('[data-hotspot-content]').value
      : null;
    this.active = false;
    this.index = this.getAttribute('data-index');

    this.bind();
  }

  // This function is invoked manually when we programatically create these in the hotspot editor on click
  // Otherwise the markup is output in liquid as part of the pre-population when we have prior hotspot data saved
  generateHTML() {
    this.classList.add('hotspot__button');
    this.style.left = this.leftOffset + '%';
    this.style.top = this.topOffset + '%';

    const icon = document.createElement('div');
    icon.classList.add('hotspot__icon');
    const dot = document.createElement('span');
    dot.classList.add('hotspot__dot');

    icon.appendChild(dot);
    this.appendChild(icon);

    const content = document.createElement('div');
    content.classList.add('hotspot__content');

    const titleInput = document.createElement('input');
    titleInput.type = 'text';
    titleInput.placeholder = 'Hotspot Title';
    titleInput.setAttribute('data-hotspot-title', '');

    const contentTextarea = document.createElement('textarea');
    contentTextarea.placeholder = 'Hotspot Content';
    contentTextarea.setAttribute('data-hotspot-content', '');

    const removeButton = document.createElement('button');
    removeButton.classList.add('hotspot__remove');
    removeButton.setAttribute('data-remove-hotspot', '');
    removeButton.innerText = 'Remove Hotspot';

    content.appendChild(titleInput);
    content.appendChild(contentTextarea);
    content.appendChild(removeButton);

    this.appendChild(content);
  }

  bind() {
    const button = this;
    const removeButton = button.querySelector('[data-remove-hotspot]');
    const hotspotTitle = button.querySelector('[data-hotspot-title]');
    const hotspotContent = button.querySelector('[data-hotspot-content]');
    const hotspotDot = button.querySelector('[data-hotspot-dot]');
    const showButton = button.querySelector('.hotspot__dot');

    if (hotspotTitle) {
      hotspotTitle.addEventListener('keyup', function (e) {
        button.hotspotTitle = e.target.value;
      });
    }

    if (hotspotContent) {
      hotspotContent.addEventListener('keyup', function (e) {
        button.hotspotContent = e.target.value;
      });
    }

    if (removeButton) {
      removeButton.addEventListener('click', function (e) {
        button.remove();
      });
    }

    if (hotspotDot) {
      hotspotDot.addEventListener('click', function () {
        if (!button.classList.contains('active')) {
          const siblings = button.parentElement.querySelectorAll('hotspot-button');
          siblings.forEach((sibling) => {
            sibling.deactivate();
          });
          button.activate();
          button.toggleAccordion();
        } else {
          button.deactivate();
          button.toggleAccordion();
        }
      });
    }

    if (showButton) {
      showButton.addEventListener('click', function () {
        if (button.querySelector('.hotspot__content'))
          button.querySelector('.hotspot__content').classList.toggle('hidden');
      });
    }
  }

  activate() {
    if (this.active) return;
    this.classList.add('active');
    this.active = true;
  }

  deactivate() {
    if (!this.active) return;
    this.active = false;
    this.classList.remove('active');
  }

  toggleAccordion() {
    const parent = this.closest('.hotspot-image');
    if (!parent) return;
    const accordion = parent.querySelector(`hotspot-accordion-component[data-index='${this.index}']`);
    if (!accordion) return;
    accordion.toggleAccordion();
  }
}

customElements.define('hotspot-button', HotspotButton);

class HotspotSlide extends HTMLElement {
  constructor() {
    super();
    this.hotspots = [];

    this.bind();
  }

  bind() {
    const hotspot = this;

    const image = hotspot.querySelector('img');
    image.addEventListener('click', function (e) {
      const bounding = e.target.getBoundingClientRect();
      const imageHeight = e.target.clientHeight;
      const imageWidth = e.target.clientWidth;

      const x = e.clientX - bounding.left;
      const y = e.clientY - bounding.top;

      const offsetLeft = ((100 * x) / imageWidth).toFixed(0);
      const offsetTop = ((100 * y) / imageHeight).toFixed(0);
      hotspot.addHotspot(offsetLeft, offsetTop);
    });
  }

  addHotspot(offsetLeft, offsetTop) {
    const hotspot = document.createElement('hotspot-button');
    hotspot.leftOffset = offsetLeft;
    hotspot.topOffset = offsetTop;
    hotspot.parent = this.closest('hotspot-generator');
    hotspot.generateHTML();
    hotspot.bind();
    this.hotspots.push(hotspot);
    this.querySelector('[data-hotspot-image-container]').appendChild(this.hotspots[this.hotspots.length - 1]);
  }
}

customElements.define('hotspot-slide', HotspotSlide);

class HotspotGenerator extends HTMLElement {
  constructor() {
    super();
    this.exportButton = this.querySelector('[data-export]');
    this.slideContainer = this.querySelector('[data-slides]');
    this.jsonToggle = this.querySelector('[data-toggle-json]');
    this.jsonModal = this.querySelector('[data-modal]');
    this.jsonOutput = this.querySelector('[data-json]');

    this.bind();
  }

  bind() {
    const hotspot = this;

    this.exportButton.addEventListener('click', function () {
      hotspot.exportData();
    });

    this.jsonToggle.addEventListener('click', function (e) {
      e.preventDefault();
      hotspot.toggleModal();
    });

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('modal-background')) {
        hotspot.jsonModal.classList.remove('modal--active');
        document.body.classList.remove('disable-scroll');
      }
    });
  }

  exportData() {
    const hotspots = this.querySelectorAll('hotspot-button');
    if (!hotspots.length) return;
    let data = '';
    hotspots.forEach((hotspot) => {
      data += `
      <object>
        <key>offsetLeft</key><value>${hotspot.leftOffset}</value>
        <key>offsetTop</key><value>${hotspot.topOffset}</value>
        <key>hotspotTitle</key><value>${hotspot.hotspotTitle}</value>
        <key>hotspotContent</key><value>${hotspot.hotspotContent}</value>
      </object>
      `;
    });
    if (!data) return;
    this.jsonOutput.innerHTML = `<pre></pre>`;
    this.jsonOutput.querySelector('pre').textContent = data;
    this.jsonModal.classList.add('modal--active');
    document.body.classList.add('disable-scroll');
  }

  toggleModal() {
    if (this.jsonModal.classList.contains('modal--active')) {
      this.jsonModal.classList.remove('modal--active');
      document.body.classList.remove('disable-scroll');
    } else {
      this.jsonModal.classList.add('modal--active');
      document.body.classList.add('disable-scroll');
    }
  }
}

customElements.define('hotspot-generator', HotspotGenerator);
